/* eslint-disable no-useless-escape */
import React, { useEffect } from 'react';

import { useNavigate, useParams, useLocation } from 'react-router-dom';

import AlertBar from 'components/layout/AlertBar';
import ExpiredSession from 'components/layout/ExpiredSession';
import useUser from 'services/cognito/user';
import LoadingPageCentralized from '../LoadingPageCentralized';

export default function PrivateRoute({
  authorization,
  element: Component,
}) {
  const navigate = useNavigate();
  const { user } = useUser();
  const { pid, id } = useParams(); // Pega os parâmetros da URL
  const location = useLocation();

  useEffect(() => {
    if (!user) {
      navigate('/login'); // Primeiro, verifica o login
      return; // Importante: Sai da função se não estiver logado
    }

    // Se estiver logado, faz o redirecionamento do Bed
    if (location.pathname === '/bed/<span class="math-inline">\{pid\}/</span>{id}' || location.pathname === '/bed/<span class="math-inline">\{pid\}/</span>{id}/') {
      navigate('/bed/<span class="math-inline">\{pid\}/</span>{id}/monitor/dashboard', { replace: true });
    }
  }, [navigate, user, pid, id, location]);

  if (!authorization) return <div>Não autorizado</div>;
  if (!user && !process.env.REACT_APP_IS_DEMO) return <LoadingPageCentralized />;

  return (
    <>
      <AlertBar />
      <ExpiredSession />
      <Component />
    </>
  );
}
